import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';
import { AxiosResponse } from 'axios';
import {
  CreateSourceDto,
  Source,
  SourceListResponse,
  UpdateSourceDto,
} from './SourceControl.type';

let listRequest: any = null;

const REQUEST_PREFIX = 'source';

export const sourceControlService = {
  getList: (
    params: {
      q?: string;
      page?: number | string;
      sort?: string;
    },
  ): Promise<AxiosResponse<SourceListResponse>> => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();

    

    return axios.get(getEndpointBase(`${REQUEST_PREFIX}/list`), {
      cancelToken: listRequest.token,
      params,
    });
  },

  create: (data: CreateSourceDto): Promise<AxiosResponse<Source>> => {
    return axios.post(getEndpointBase(`${REQUEST_PREFIX}/create`), data);
  },

  update: (data: UpdateSourceDto): Promise<AxiosResponse<Source>> => {
    return axios.put(getEndpointBase(`${REQUEST_PREFIX}/${data.id}`), data);
  },

  delete: (id: number): Promise<AxiosResponse> => {
    return axios.delete(getEndpointBase(`${REQUEST_PREFIX}/${id}`));
  },
};
